import { useState, useEffect, useMemo, useCallback } from 'react';

const useComplexPassword = (password) => {

    const MINIMUM_CRITERIA = useMemo(() => {
        return [
            {
                regex: /[a-z]/,
                error: 'error_password_least_one_lowercase',
            },
            {
                regex: /[A-Z]/,
                error: 'error_password_least_one_uppercase',
            },
            {
                regex: /[0-9]/,
                error: 'error_password_least_one_number',
            },
            {
                regex: /[!@#$%^&*(),.?":{}|<>+-/_=]/,
                error: 'error_password_least_one_special',
            },
            {
                regex: /^.{8,}$/,
                error: 'error_password_must_least_8_char'
            }
        ]
    }, [])

    const VALIDATION_CRITERIA = useMemo(() => {
        return [
            {
                regex: /^[A-Za-z0-9!@#$%^&*(),.?":{}|<>+-/_=]+$/,
                error: 'error_password_format'
            },
            {
                regex: /^\S*$/,
                error: 'error_password_must_not_contain_spaces'
            },
        ]
    }, [])

    const STRENGTH_LEVELS = useMemo(() => {
        return [
            { background: '#F2F4F7', text: 'password_strength' },
            { background: '#F44336', text: 'very_weak' },
            { background: '#FFF422', text: 'weak' },
            { background: '#4CAF50', text: 'good' },
            { background: '#4CAF50', text: 'strong' },
            { background: '#4CAF50', text: 'strong' },
        ]
    }, [])

    const [strengthLevelConfig, setStrengthLevelConfig] = useState({
        strengthPoint: 0,
        background: '#F2F4F7',
        text: 'password_strength',
    });

    const [errors, setErrors] = useState([]);

    const [isEnforceChangePassword, setIsEnforceChangePassword] = useState(false);

    const handleSetStrengthLevelConfig = useCallback((password) => {
        let level = 0;

        MINIMUM_CRITERIA.forEach(({ regex, error }) => {
            if (regex.test(password)) {
                level++;
            }
        });

        const strengthLevel = Math.min(level, STRENGTH_LEVELS.length - 1);

        const strengthLevelConfig = STRENGTH_LEVELS[strengthLevel]

        setStrengthLevelConfig({
            strengthPoint: strengthLevel,
            background: strengthLevelConfig.background,
            text: strengthLevelConfig.text,
        })

        setIsEnforceChangePassword(level < 5) 
    }, [])

    const handleSetErrorValidation = useCallback((password) => {
        const errors = [];

        [...MINIMUM_CRITERIA, ...VALIDATION_CRITERIA].forEach(({ regex, error }) => {
            if (!regex.test(password)) {
                errors.push(error);
            }
        });

        setErrors(errors);
    }, [])

    useEffect(() => {

        handleSetStrengthLevelConfig(password);

        handleSetErrorValidation(password);

    }, [password]);

    return { strengthLevelConfig, errors, isEnforceChangePassword };
};

export default useComplexPassword;